<template>
  <v-main :class="{ 'pt-0': latest }">
    <v-container
      class="col-10 pa-0 ma-0-auto pb-16"
      :class="{ 'page-wrapper': !latest }"
    >
      <div class="pa-0 py-10">
        <h4 class="page-title" v-if="!latest">{{ $t('News') }}</h4>
        <h4 class="page-title" v-if="latest">{{ $t('LatestNews') }}</h4>
        <v-divider class="accent thick-divider green" width="100%"></v-divider>
      </div>
      <v-row v-if="orderedArticles.length">
        <v-col
          v-for="(article, i) in orderedArticles"
          :key="i"
          class="col-12 col-sm-6 col-lg-4 pt-0 px-5 pb-10"
        >
          <ArticleCard :article="article.fields" />
        </v-col>
      </v-row>
      <v-row v-if="orderedArticles.length === 0">{{ $t('NoNews') }}</v-row>

      <v-row
        v-if="latest && orderedArticles.length"
        class="layout align-center justify-center d-flex mt-4 mb-8"
      >
        <v-btn
          rounded
          x-large
          elevation="8"
          class="green white--text page-button my-10"
          to="/news/"
        >
          {{ $t('SeeAlltheNews') }}
        </v-btn>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import ArticleCard from '@/components/ArticleCard'
import _ from 'lodash'
//import { orderBy } from 'lodash/core'

export default {
  name: 'ArticlesList',
  components: { ArticleCard },
  props: {
    latest: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    orderedArticles: function() {
      let allArticlesOrdered = _.orderBy(
        this.articles,
        ['fields.data'],
        ['desc']
      )

      if (this.latest && allArticlesOrdered.length) {
        allArticlesOrdered = allArticlesOrdered.slice(0, this.nLatestNews)
      }

      return allArticlesOrdered
    },
  },
  data() {
    return {
      articles: this.getNews(),
      nLatestNews: 3,
    }
  },
  methods: {
    getNews() {
      this.$contentful
        .getEntries()
        .then(res => {
          this.articles = []
          if (res.items.length) {
            this.articles = res.items
          }
        })
        .catch(error => {})
    },
  },
}
</script>

<style>
.thick-divider {
  height: 3px !important;
  max-height: 3px !important;
}
</style>
